import { get_token, get_user_details } from "@/router";
import Loader from "@/components/Loader/LoaderView";
import CreateEvent from "@/components/FloatingButton/FloatingButtonComponent.vue";
import Swal from 'sweetalert2';


export default {
  components: {
    Loader,
    CreateEvent
  },
  data() {
    return ({
      events: [],
      loading: true,
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
      },
      fileName: "",
      fileError: "",
      upload_media: null,
      imagePreview: null,
      token_exists: false,
      user_id: null,
      errors: {},
      showExtrasForm: false,
      show_add_extras: true,
      event_link: "",
      event_types: [],
      is_recurring: false,
      recurring_type:'',
      recurring_patterns: [],
      event_type: '',
      eventExtras: [],
      extraForms: [],
      extraItems: [],
      event_name: "",
      description: "",
      start_date: "",
      start_time: '',
      end_date: "",
      end_time: '',
      rsvp_start_date: "",
      rsvp_start_time: '',
      rsvp_end_date: "",
      rsvp_end_time: '',
      organizer: "",
      location: "",
      portal_id: "",
      item_name: '',
      item_description: '',
      item_price: 0,
    })
  },
  mounted() {
    this.user_details = get_user_details();
    this.user_id = this.get_user_id();
    this.token_exists = get_token();
    this.fetchEventTypes();
    this.fetchRecurringTypes();
    this.filter_events();
    this.fetchExtras();


  },
  watch: {
    selectedExtraText(newVal) {
      this.filterExtras(newVal);
    },
    event_name(newValue) {
      if (newValue.trim()) this.errors.event_name = null;
    },
    location(newValue) {
      if (newValue.trim()) this.errors.location = null;
    },
    organizer(newValue) {
      if (newValue.trim()) this.errors.organizer = null;
    },
    start_date() {
      this.errors.start_date = null;
    },
    end_date() {
      this.errors.end_date = null;
    },
    rsvp_start_date() {
      this.errors.rsvp_start_date = null;
    },
    rsvp_end_date() {
      this.errors.rsvp_end_date = null;
    },
    event_type: {
      handler(newType) {
        if (newType.name !== "online") {
          this.$nextTick(() => {
            this.initializeMap();

          });
        }
      },
      deep: true
    },
    events: {
      handler() {
        this.$nextTick(() => {
          // Prevent reinitializing if already initialized
          if ($.fn.DataTable.isDataTable('#rsvpTable')) {
            $('#rsvpTable').DataTable().destroy();
          }

          $('#rsvpTable').DataTable({
            paging: true,
            searching: true,
            ordering: true,
            info: true,
            lengthChange: true,
            pageLength: 10,
            language: {
              paginate: {
                previous: "Previous",
                next: "Next"
              },
              info: "Showing _START_ to _END_ of _TOTAL_ entries",
              infoEmpty: "No entries available"
            }
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleFileUpload(event) {

      const file = event.target.files[0];

      if (file) {
        if (file.type.startsWith("audio/")) {
          this.fileError = "Audio files are not allowed.";
          this.upload_media = null;
          this.fileName = "";
          this.imagePreview = null; // Reset preview if an invalid file is selected
          event.target.value = ""; // Clear file input
        } else {
          this.fileName = file.name;
          this.fileError = "";
          this.upload_media = file;

          // Check if the file is an image before previewing
          if (file.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => {
              this.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
          } else {
            this.imagePreview = null; // Reset preview for non-image files
          }
        }
      } else {
        this.fileName = "";
        this.fileError = "";
        this.upload_media = null;
        this.imagePreview = null;
      }
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    getToken() {
      return get_token();
    },

    initializeMap() {
      const defaultLat = parseFloat(this.latitude || 0);
      const defaultLng = parseFloat(this.longitude || 0);

      const mapOptions = {
        center: { lat: defaultLat, lng: defaultLng },
        zoom: 8,
        mapTypeId: 'roadmap',
      };

      const mapElement = document.querySelector('#mapSearchBox');
      if (mapElement) {
        const map = new window.google.maps.Map(mapElement, mapOptions);

        let marker = null;

        const input = document.getElementById('mapSearchBox');
        const searchBox = new window.google.maps.places.SearchBox(input);

        map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(input);

        map.addListener('bounds_changed', () => {
          searchBox.setBounds(map.getBounds());
        });

        searchBox.addListener('places_changed', () => {
          const places = searchBox.getPlaces();

          if (!places || places.length === 0) {
            return;
          }

          const place = places[0];
          if (!place.geometry) {
            return;
          }

          // Update map center and zoom
          map.setCenter(place.geometry.location);
          map.setZoom(14);

          // Remove the existing marker, if any
          if (marker) {
            marker.setMap(null);
          }

          marker = new window.google.maps.Marker({
            position: place.geometry.location,
            map: map,
            title: place.name,
          });
          this.location = input.value;
        });
      }
    },
    filter_events() {
      this.token_exists = get_token();

      const portal_id = this.$route.params.portal_id
      const payload = {
        filter_values: {
          portal_id: portal_id

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_events_api/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        data: JSON.stringify(payload),
        success: (data) => {
          this.events = data.data.events;

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate();
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      return `${weekday} ${day}${suffix}`;
    },

    form_time(timeString) {
      if (!timeString) return "";
      const [hour, minute] = timeString.split(":");
      const date = new Date();
      date.setHours(hour, minute);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },

    daysUntil(dateStr) {
      const today = new Date();
      const eventDate = new Date(dateStr);

      // Zero out time for accurate diff
      today.setHours(0, 0, 0, 0);
      eventDate.setHours(0, 0, 0, 0);

      const diffTime = eventDate - today;
      const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

      if (diffDays < 0) {
        return 'Event has passed';
      } else if (diffDays === 0) {
        return 'Starts today';
      } else if (diffDays < 7) {
        return `Starts in ${diffDays} day${diffDays > 1 ? 's' : ''}`;
      } else {
        const weeks = Math.floor(diffDays / 7);
        const remainingDays = diffDays % 7;
        let result = `Starts in ${weeks} week${weeks > 1 ? 's' : ''}`;
        if (remainingDays > 0) {
          result += ` and ${remainingDays} day${remainingDays > 1 ? 's' : ''}`;
        }
        return result;
      }
    },

    fetchExtras() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_extra/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (data) => {
          this.extras = data.extras;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    addMoreExtra() {
      const extraItem = {
        selectedExtraText: this.selectedExtraText,
        item_name: this.item_name,
        item_description: this.item_description,
        item_price: this.item_price,
      };
      this.extraForms.push(extraItem);
      this.selectedExtraText = '';
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
    },

    handleCollapseToggle() {
      this.isCollapseOpen = !this.isCollapseOpen;

      if (this.isCollapseOpen) {
        this.addMoreExtra();
      }
    },
    addExtra() {
      this.show_add_extras = true
      this.showExtrasForm = true;
      this.extraForms.push({
        selectedExtra: "",
        items: [
          { item_name: '', item_description: '', item_price: '' }
        ]
      });
    },

    addExtraItem(extra_index) {
      const extra_form = this.extraForms.at(extra_index);

      if (extra_form) {
        const new_item = {
          item_name: '',
          item_description: '',
          item_price: 0
        };

        if (this.validate_extra_item(new_item)) {
          extra_form.items.push(new_item);
        }
      }
    },

    validate_extra_item(item) {
      return (
        typeof item === 'object' &&
        item !== null &&
        typeof item.item_name === 'string' &&
        typeof item.item_description === 'string' &&
        typeof item.item_price === 'number' &&
        item.item_price >= 0
      );
    },

    removeExtra(extraIndex) {
      this.extraForms.splice(extraIndex, 1);
    },

    fetchEvents_extras(event_id) {
      this.selectEvent.id = event_id;
      this.isLoading = true;
      this.token_exists = get_token();
      this.clearForm()
      this.selectedItemId = []

      // Close the event modal before making the request
      $('#eventModal').modal('hide');

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_event_data/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { event_id: event_id },
        success: (response_data) => {
          this.eventExtras = response_data.event_extras;
          if (this.eventExtras && this.eventExtras.length > 0) {
            $('#rsvp_modal').modal('show'); // Open RSVP modal
          } else {
            this.addRsvp(); // Call addRsvp if no extra details
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    fetchEventTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_event_types/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.event_types = response.data.event_type;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    fetchRecurringTypes() {
      this.isLoading = true;
      this.token_exists = get_token();
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_recurring_pattern/`,
        method: "GET",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.recurring_patterns = response.data.recurring_patterns;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    submitEvent() {
      if (this.event_id) {
        this.update_event(this.event_id);
      } else {
        this.submit_event_form();
      }
    },

    load_event() {

      this.filter_events();

      $("#update_event_modal").modal("hide");
      $('#event_modal').modal('hide');


      this.event_id = null;
      this.event_name = "";
      this.description = "";
      this.start_date = "";
      this.start_time = "";
      this.end_date = "";
      this.end_time = "";
      this.rsvp_start_date = "";
      this.rsvp_start_time = "";
      this.rsvp_end_date = "";
      this.rsvp_end_time = "";
      this.organizer = "";
      this.location = "";
      this.files = [];
    },
    validationEventForm() {
      this.errors = {};
      let valid = true;

      if (!this.event_name) {
        this.errors.event_name = 'Event name is required';
        valid = false;
      }

      return valid;
    },
    clearForm() {
      this.item_name = '';
      this.item_description = '';
      this.item_price = '';
      this.extraItems = [];
      this.event_name = '';
      this.start_date = '';
      this.end_date = '';
      this.event_description = '';
      this.selectedPortalId = '';
      this.organizer = '';
      this.location = '';
      this.rsvp_start_date = '';
      this.rsvp_end_date = '';
      this.upload_media = null;
      this.selectedExtraText = '';
      this.event_type = '';
      if (this.$refs.quillEventEditorRef) {
        this.$refs.quillEventEditorRef.setHTML('');

      };
      this.extraForms = [];

    },
validate_event_details() {
  let isValid = true;

  if (!this.organizer?.trim()) {
    this.errors.organizer = 'Organizer is required';
    isValid = false;
  }

  if (!this.event_name?.trim()) {
    this.errors.event_name = 'Event name is required';
    isValid = false;
  }

  return isValid;
},

validate_event_location_and_link() {
  let isValid = true;

  if (this.event_type.name === 'hybrid' || this.event_type.name === 'physical') {
    if (!this.location?.trim()) {
      this.errors.location = 'Location is required';
      isValid = false;
    }
  }

  if (this.event_type.name === 'online' || this.event_type.name === 'hybrid') {
    if (!this.event_link?.trim()) {
      this.errors.event_link = 'Event link is required for online/hybrid events.';
      isValid = false;
    }
  }

  return isValid;
},
validate_extra_forms() {
  let isValid = true;

  this.extraForms.forEach((extraForm, index) => {
    if (extraForm.selectedExtra) {
      extraForm.items.forEach((item, itemIndex) => {
        if (!item.item_name) {
          this.errors[`extra_${index}_item_${itemIndex}_name`] = "Item name is required.";
          isValid = false;
        }
      });
    }
  });

  return isValid;
},
validate_event_dates() {
  const normalizeDate = (dateStr) => {
    const d = new Date(dateStr);
    return new Date(d.setHours(0, 0, 0, 0));
  };

  const isMissingDateFields = !this.start_date || !this.end_date || !this.rsvp_start_date || !this.rsvp_end_date;

  const today = normalizeDate(new Date());
  const startDate = normalizeDate(this.start_date);
  const endDate = normalizeDate(this.end_date);
  const rsvpStart = normalizeDate(this.rsvp_start_date);
  const rsvpEnd = normalizeDate(this.rsvp_end_date);

  this.errors = new Map(); // clear previous errors

  if (isMissingDateFields) {
    const errorMsg = 'All dates are required';
    this.errors.start_date = this.errors.end_date = this.errors.rsvp_start_date = this.errors.rsvp_end_date = errorMsg;
    return false;
  }

  let isValid = true;

  const addError = (field, message) => {
    this.errors.set(field, message);
    isValid = false;
  };

  if (startDate < today) {
    addError('start_date', 'Event Start Date must be today or a future date');
  }

  if (endDate < startDate) {
    addError('end_date', 'Event End Date must be after Event Start Date');
  }

  if (rsvpStart > startDate) {
    addError('rsvp_start_date', 'RSVP Start Date must be today or before Event Start Date');
  }

  if (rsvpEnd < rsvpStart || rsvpEnd > startDate) {
    addError('rsvp_end_date', 'RSVP End Date must be after RSVP Start Date and on or before Event Start Date');
  }

  return isValid;
},

     validation_event_form() {
  this.errors = {};
  let isValid = true;

  isValid = this.validate_event_details() && isValid;
  isValid = this.validate_event_location_and_link() && isValid;
  isValid = this.validate_event_dates() && isValid;
  isValid = this.validate_extra_forms() && isValid;

  return isValid;
},
    submit_event_form() {
      this.is_valid = true
      if (!this.validation_event_form()) {
        return;
      }

      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const event_url = `${window.location.origin}${this.$route.path}`

      this.isSubmitting = true;
      const newItem = {
        item_name: this.item_name,
        description: this.item_description,
        price: this.item_price
      };
      this.extraItems.push(newItem);

      const formData = new FormData();
      formData.append('event_name', this.event_name);
      formData.append('start_date', this.start_date);
      formData.append('start_time', this.start_time);
      formData.append('end_date', this.end_date);
      formData.append('end_time', this.end_time);
      this.event_description = this.$refs.quillEventEditorRef.getHTML();
      formData.append('description', this.event_description);
      formData.append('portal_id', this.$route.params.portal_id);
      formData.append('organizer', this.organizer);
      formData.append('location', this.location);
      formData.append('rsvp_start_date', this.rsvp_start_date);
      formData.append('rsvp_start_time', this.rsvp_start_time);
      formData.append('rsvp_end_date', this.rsvp_end_date);
      formData.append('rsvp_end_time', this.rsvp_end_time);
      formData.append('event_type', this.event_type.id);
      formData.append('event_link', this.event_link);
      formData.append('event_url', event_url)
      formData.append('is_recurring', this.is_recurring);
      if (this.is_recurring && this.recurring_type) {
  formData.append('recurring_type', this.recurring_type);
}


      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }

      const extras_data = [];

      this.extraForms.forEach(extra => {
        if (extra.selectedExtra && extra.selectedExtra.trim()) {
          const validItems = [];

          extra.items.forEach(item => {
            if (item.item_name && item.item_name.trim()) {
              validItems.push({
                item_name: item.item_name.trim(),
                description: item.item_description?.trim(),
                price: item.item_price || 0
              });
            }
          });

          if (validItems.length > 0) {
            extras_data.push({
              extra_name: extra.selectedExtra.trim(),
              items: validItems
            });
          }
        }
      });

      if (extras_data.length > 0) {
        formData.append('extra', JSON.stringify(extras_data));
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_event_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const status = response.status;
          this.$emit('new_event', response.event)
          Swal.close();
          if (status === "success") {
            Swal.fire({
              icon: 'success',
              title: 'Event Created',
              showConfirmButton: false,
              timer: 2000,
            }).then(() => {
              $('#event_modal').modal('hide');
              this.isDropdownVisible = false;
              this.clearForm();
              this.load_event();
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.event_name = response_data.message;
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },

    selectDay(day) {
      if (!day.date) return; // Ensure the day has a valid date

      this.selectedDay = day.dayNumber;
      this.selectedDate = day.date;

      const saDate = new Date(this.selectedDate).toLocaleDateString("en-CA", {
        timeZone: "Africa/Johannesburg",
      });


      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_events_by_date/`,
        method: 'POST',
        data: JSON.stringify({ event_start_date: saDate }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === 'success' && response.events && response.events.length > 0) {
            this.events = response.events;
            this.message = '';
          } else {
            this.events = [];
            this.message = 'No events found.';
          }
        },
        error: () => {
          this.events = [];
          this.message = 'No events found.';
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
  },



};